import { ICluster, IPositionCoordinator, IContact } from '@nkr/models/index';
import JoditEditor from '@nkr/components/editor';
import config from '@nkr/views/ticketing/jodit-editor-config';
import Swaps from '../common/swaps';
import Coordinators from '../common/coordinators';
import SwapManager from '../common/swap-manager';

interface IProps {
    message: string,
    extra: string[],
    swaps: ICluster[],
    coordinators: IPositionCoordinator[],
    swapManager: IContact,
    deadlineDate: string,
    deadlineTime: string,
    canDoVirtual: boolean,
    onMessageChange: (message: string) => void
}

const MatchOfferAccepted = (props: IProps) => {
    const handleMessageChange = (message: string) => {
        props.onMessageChange(message);
    };

    const joditConfig = { ...config, height: '300px' };

    let centerId = props.swaps[0].positions[0].recipient.centerId;

    return (
        <>
            <JoditEditor
                value={props.message}
                config={joditConfig}
                onChange={handleMessageChange}
                onBlur={() => null}
            />
            <br />

            <div style={{ marginBottom: 20 }}>
                Donor record review deadline is <span style={{ color: 'red' }}>{props.deadlineDate}</span> <span style={{ color: 'red' }}>{props.deadlineTime}</span> ET.
                <br /><br />
                Donor record review requires the completion of an acceptable virtual crossmatch.  To record results <a href={__ADMIN__ + '/center/' + centerId + '/action-center/pending-swaps'}>click here</a>.
            </div>

            {props.canDoVirtual && (
                <div style={{ marginBottom: 20 }}>
                    If a cryo vial is needed for this swap, please order it from the pending swaps page.
                </div>
            )}

            <div style={{ marginBottom: 5 }}><strong>Swap Configuration</strong></div>

            <Swaps includePreselectStatus={true} swaps={props.swaps} />

            <div style={{ marginBottom: 5 }}><strong>Coordinator Contact Information</strong></div>

            <Coordinators coordinators={props.coordinators} />

            <div style={{ marginBottom: 5 }}><strong>Swap Manager</strong></div>

            <SwapManager data={props.swapManager} />
        </>
    );
}

export default MatchOfferAccepted;